import { render, staticRenderFns } from "./AxAppFailureReadOnly.vue?vue&type=template&id=8edac7fa&"
import script from "./AxAppFailureReadOnly.vue?vue&type=script&lang=ts&"
export * from "./AxAppFailureReadOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports